import {StaticQuery, graphql, Link } from 'gatsby'
import React from 'react'
import './styles/Schedule.scss'

import SpeakerSmallTag from './SpeakerSmallTag'

function formatAMPM(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0'+minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
  }

  function getTimezoneLabel(offset)
  {
    switch(offset){
        case("UTC+1"):
            return "BST";
        case("UTC+2"):
            return "CEST";
        case("UTC-4"):
            return "EDT";
        case("UTC-5"):
            return "EST";
        case("UTC-6"):
            return "CST";
        case("UTC-7"):
            return "PDT";
        case("UTC-8"):
            return "PST";
        case("UTC-9"):
            return "AKST";
        case("UTC-10"):
            return "HST";

        default: 
            return offset;
    }
  }

let  isCurrentDate = 12

const Shedule = () => {
    return (
    <StaticQuery
        query={graphql`
        query SheduleQuery {
            allSessionizeSessionsJson {
                nodes {
                  id
                  description
                  title
                  startsAt
                  isServiceSession
                  categories {
                    categoryItems {
                      id
                      name
                    }
                  }
                  speakers {
                    id
                    name
                  }
                }
              }
            allSessionizeSpeakersJson {
                nodes {
                    id
                    fullName
                    tagLine
                    profilePicture
                }
            }
          }
          
        `}
        render={data => (
            <section id="schedule" className="Shedule schedule-refresh schedule-page schedule-avatar">
                {data.allSessionizeSessionsJson.nodes.map(ss => {
                    let spInfo = [];
                    const isSession = !ss.isServiceSession;
                    let className = '';
                    if (isSession) {
                        
                        for(let i=0; i<ss.speakers.length; i++){
                            let spId = ss.speakers[i].id;
                            
                            spInfo[i]  = data.allSessionizeSpeakersJson.nodes.find(speaker => {
                                return speaker.id === spId;
                            });
                            
                            
                        }
                        // console.log(ss.categories[0]);
                        //checks if it's a keynote
                        /*if(ss.categories !== undefined && ss.categories.length && ss.categories[0].categoryItems.length){
                            for(let j=0; j<ss.categories[0].categoryItems.length; j++){
                                switch(ss.categories[0].categoryItems[j].name){
                                    case("Keynote"):
                                        className = 'keynote';

                                }
                            }
                            
                        }*/

                    }

                    //process the  date time per timezone
                    const sTime = new Date(ss.startsAt);
                    var sTimeStr = formatAMPM(sTime); 
                    let offset = sTime.getTimezoneOffset()*-1/60;
                    let sTimeZ = 'UTC';
                    if(offset>0){
                        sTimeZ += "+";
                    }
                    sTimeZ+=offset;
                    sTimeZ = getTimezoneLabel(sTimeZ);
                    let  sDate = '';
                    let wDate = false;
                    if(sTime.getDate() != 14){ //hardcoded for the date of the conference
                        wDate = true;
                        sDate =  'February ' + sTime.getDate();
                    }

                    let session;
                    if(isSession) {
                        session = <Link to={`/sessions/${ss.id.toString()}`}>
                        <h4>{ss.title}&nbsp;<span>→</span></h4>
                        { isSession && 
                            <SpeakerSmallTag info={spInfo} />
                        }
                        </Link>;
                    }else{
                        session = <div className="sTagline">{ss.title}</div>;
                    }

                    let subHeader = ''
                    if (sTime.getDate() != isCurrentDate) {
                        isCurrentDate = sTime.getDate()
                        subHeader = <>
                            <h2 className="subHeader">February {isCurrentDate}, 2025</h2>
                            <div className="scheduleFootnote">All times are shown in your timezone. As per your system settings</div>
                        </>
                    }

                    return (
                    <>
                        { subHeader }
                        <article id={ss.id.toString()} className={className} key={ss.id.toString()}>
                            
                            <div className="time">
                                {sTimeStr}
                                <div className="timezone">{sTimeZ}</div>
                            </div>
                            <div className={`sessionInfo ${ isSession ? '' : 'breakSession' } `}>
                                {session}
                            </div>
                        </article>
                    </>
                )})}
            </section>
        )}
        />
    )
}

export default Shedule